module.exports = __webpack_public_path__ + "img/9.00a9f853.png";